import {
  CREATEORDERS,
  GETORDERS,
  DELETEORDERS,
  UPDATEORDERS,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETORDERS:
      return {
        ...state,
        ordersList: action.payload.data,
      };
    case UPDATEORDERS:
      return {
        ...state,
        ordersUpdateStatus: action.payload.success,
      };

    case DELETEORDERS:
      return {
        ...state,
        ordersList: state.ordersList.filter(
          (item) => item.id !== action.orderId,
        ),
        ordersDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
